import { module } from 'modujs'

export default class extends module {
    constructor(m) {
        super(m)
    }
    
    ///////////////
    // Callbacks
    ///////////////
    onScrollProgress(progress) {
        this.call('onProgress', progress, 'HeroAbout')
    }
}
